import React, { useState } from 'react';
import axios from 'axios';
import { Upload, X, Image as ImageIcon } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ImageUpload = ({ value, onChange, label = "Upload Gambar" }) => {
  const inputId = React.useId();
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(value || '');

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      toast.error('File harus berupa gambar');
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Ukuran file maksimal 5MB');
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const { data } = await axios.post(`${API_URL}/api/upload`, formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const imageUrl = `${API_URL}${data.url}`;
      setPreview(imageUrl);
      onChange(imageUrl);
      toast.success('Gambar berhasil diupload!');
    } catch (error) {
      console.error('Upload error:', error);
      toast.error(error.response?.data?.detail || 'Upload gagal');
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = () => {
    setPreview('');
    onChange('');
  };

  return (
    <div>
      <label className="block text-sm font-body font-medium text-text-primary mb-2">
        {label}
      </label>

      {preview ? (
        <div className="relative group">
          <img
            src={preview}
            alt="Preview"
            className="w-full h-48 object-cover rounded-xl border border-stone-200"
          />
          <button
            type="button"
            onClick={handleRemove}
            className="absolute top-2 right-2 p-2 bg-red-500 hover:bg-red-600 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <div className="relative">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            disabled={uploading}
            className="hidden"
            id={inputId}
          />
          <label
            htmlFor={inputId}
            className={`flex flex-col items-center justify-center w-full h-48 border-2 border-dashed border-stone-300 rounded-xl cursor-pointer hover:border-emerald-500 transition-colors ${
              uploading ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {uploading ? (
              <>
                <div className="animate-spin rounded-full h-12 w-12 border-4 border-emerald-200 border-t-emerald-700 mb-3" />
                <span className="text-sm font-body text-text-secondary">Uploading...</span>
              </>
            ) : (
              <>
                <Upload className="w-12 h-12 text-stone-400 mb-3" />
                <span className="text-sm font-body text-text-primary font-medium mb-1">
                  Click untuk upload gambar
                </span>
                <span className="text-xs font-body text-text-secondary">
                  PNG, JPG, WEBP (Max 5MB)
                </span>
              </>
            )}
          </label>
        </div>
      )}

      <p className="text-xs text-text-secondary mt-2 font-body">
        Atau masukkan URL gambar dari Unsplash/Pexels secara manual
      </p>
    </div>
  );
};

export default ImageUpload;
